module.exports = __webpack_public_path__ + "static/media/geogames_menu.bbae64c9.png";